import siteConfig from '../data/siteConfig.json';

const AUTH_URL = import.meta.env.VITE_AUTH_URL || siteConfig.urls.auth;

export { AUTH_URL };
